module.exports = __webpack_public_path__ + "static/media/page-header2.370c1240.jpg";